const AVAILABLE_METRICS = {
  SECTION_RESTAURANT_CLICK: 'SECTION_RESTAURANT_CLICK',
  SECTION_GROCERIES_CLICK: 'SECTION_GROCERIES_CLICK',
  SECTION_PAYMENT_METHODS_CLICK: 'SECTION_PAYMENT_METHODS_CLICK',
  LOADED_EMPTY_STATE: 'LOADED_EMPTY_STATE',
  SERVER_ERROR: 'SERVER_ERROR',
  CLIENT_ERROR: 'CLIENT_ERROR',
  VENDOR_RESTAURANT_CLICK: 'VENDOR_RESTAURANT_CLICK',
  DISH_RESTAURANT_CLICK: 'DISH_RESTAURANT_CLICK',
  BANNER_RESTAURANT_CLICK: 'BANNER_RESTAURANT_CLICK',
  SHOP_GROCERIES_CLICK: 'SHOP_GROCERIES_CLICK',
  PRODUCT_GROCERIES_CLICK: 'PRODUCT_GROCERIES_CLICK',
  BANNER_GROCERIES_CLICK: 'BANNER_GROCERIES_CLICK',
  BIN_PAYMENT_CLICK: 'BIN_PAYMENT_CLICK',
  LOADED_RESTAURANTS: 'LOADED_RESTAURANTS',
  LOADED_GROCERIES: 'LOADED_GROCERIES',
  LOADED_PAYMENT_METHODS: 'LOADED_PAYMENT_METHODS',
};

module.exports = { AVAILABLE_METRICS };
